import { render, staticRenderFns } from "./BidPreview.vue?vue&type=template&id=b5f84ec2&scoped=true&"
import script from "./BidPreview.vue?vue&type=script&lang=js&"
export * from "./BidPreview.vue?vue&type=script&lang=js&"
import style0 from "./BidPreview.vue?vue&type=style&index=0&id=b5f84ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f84ec2",
  null
  
)

export default component.exports